import { TComponentsConfigs } from "components/ComponentRenderer";
import { SeeMoreComponent } from "components/misc/seeMore/SeeMoreComponent";
import { CollapsedText } from "components/misc/collapsedText/CollapsedText";

export const MISC_COMPONENTS_CONFIGS: TComponentsConfigs = {
    seeMore: { component: SeeMoreComponent },
    collapsedText: { component: CollapsedText },
};
